import React from 'react'
import { color } from '@figma/fpl-tokens/tokens.stylex'
import stylex from '@web/lib/stylex'

import { brandVars } from './brand.stylex'

const styles = stylex.create({
  brand: {
    fontFamily: brandVars.fontFamily,
    color: color.text,
    backgroundColor: color.bg,
    fontVariationSettings: brandVars.fontVariationSettings,
    fontOpticalSizing: brandVars.fontOpticalSizing,
  },
  authView: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    paddingTop: {
      default: '15vh',
      '@media (max-width: 850px)': '24px',
    },
    margin: 'auto',
    width: '100%',
  },
  fullscreen: {
    paddingTop: {
      default: 0,
      '@media (max-width: 850px)': '24px',
    },
    alignItems: {
      default: 'center',
      '@media (max-width: 850px)': 'unset',
    },
    marginTop: {
      // margin based off of the logoHeight in simple_page.css'
      // KEEP_IN_SYNC(simple_page.css)
      default: 'calc(-1 * 72px)',
      '@media (max-width: 850px)': 'unset',
    },
    /* Keep in line with $maxAuthModalWidth in auth_form.css as we convert to stylex */
    // KEEP_IN_SYNC(auth_form.css)
    maxWidth: '422px',
  },
})

export function SimplePageAuthViewWrapper({
  fullscreen = true,
  children,
}: {
  fullscreen?: boolean
  children: React.ReactNode
}) {
  return (
    <div {...stylex.props(styles.brand, styles.authView, fullscreen && styles.fullscreen)}>
      {children}
    </div>
  )
}
